
import React from 'react';
import { Switch } from '@/components/ui/switch';
import ColorVariantsSection from './ColorVariantsSection';
import SizeVariantsSection from './SizeVariantsSection';

interface ColorVariant {
  id: string;
  name: string;
  hex: string;
}

interface SizeVariant {
  id: string;
  name: string;
}

interface ProductVariantsSectionProps {
  showColorOptions: boolean;
  setShowColorOptions: React.Dispatch<React.SetStateAction<boolean>>;
  colors: ColorVariant[];
  setColors: React.Dispatch<React.SetStateAction<ColorVariant[]>>;
  showSizeOptions: boolean;
  setShowSizeOptions: React.Dispatch<React.SetStateAction<boolean>>;
  sizes: SizeVariant[];
  setSizes: React.Dispatch<React.SetStateAction<SizeVariant[]>>;
}

const ProductVariantsSection: React.FC<ProductVariantsSectionProps> = ({
  showColorOptions,
  setShowColorOptions,
  colors,
  setColors,
  showSizeOptions,
  setShowSizeOptions,
  sizes,
  setSizes,
}) => {
  return (
    <div className="space-y-4 border-t pt-4">
      <div className="flex items-center gap-2">
        <Switch 
          id="enableColors" 
          checked={showColorOptions}
          onCheckedChange={setShowColorOptions}
        />
        <label htmlFor="enableColors" className="font-medium cursor-pointer">
          This product has color variants
        </label>
      </div>
      
      {showColorOptions && (
        <ColorVariantsSection colors={colors} setColors={setColors} />
      )}
      
      <div className="flex items-center gap-2">
        <Switch 
          id="enableSizes" 
          checked={showSizeOptions}
          onCheckedChange={setShowSizeOptions}
        />
        <label htmlFor="enableSizes" className="font-medium cursor-pointer">
          This product has size variants
        </label>
      </div>
      
      {showSizeOptions && (
        <SizeVariantsSection sizes={sizes} setSizes={setSizes} />
      )}
    </div>
  );
};

export default ProductVariantsSection;
